var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightCurrentColor24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.9588C5 11.4237 5.43376 10.9899 5.96882 10.9899L15.6928 10.9899L13.8035 9.10006C13.4252 8.72165 13.4253 8.10822 13.8038 7.72994C14.1822 7.35165 14.7956 7.35175 15.1739 7.73017L18.7164 11.2738C19.0914 11.649 19.095 12.2561 18.7243 12.6357L15.1818 16.2628C14.8079 16.6456 14.1946 16.6528 13.8118 16.279C13.429 15.9051 13.4217 15.2917 13.7956 14.9089L15.7307 12.9276L5.96882 12.9276C5.43376 12.9276 5 12.4938 5 11.9588Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCurrentColor24);
export default __webpack_public_path__ + "static/media/arrow-right-currentColor-24.ab6753e6d9200ab9e04cbbcab2f60ae4.svg";
export { ForwardRef as ReactComponent };